<template>
  <div class="home py-5">
    <span class="d-flex flex-row page-title">{{$t("intranet.title.page.grape.read")}}</span>
    <div v-if="dataLoaded" class="sheet-container">
      <AveineGrapeSheet :APIbaseURL="APIbaseURL" :grape="grape" :adminMode="true" />
    </div>
    <div v-else class="d-flex justify-center align-center mt-16">
      <v-progress-circular
        indeterminate
        :size="100"
        :width="10"
        color="secondary"
      ></v-progress-circular>
    </div>
  </div>
</template>

<script>
import { AveineGrapeSheet } from 'aveine-grape';
import { Grape } from 'aveine-toolbox';
import { errorHandler } from 'aveine-toolbox'
export default {
  data () {
    return {
      grape: {},
      dataLoaded: false,
      APIbaseURL: process.env.VUE_APP_API_HOST
    }
  },
  name: 'Read',
  components: {
    AveineGrapeSheet
  },
  async created() {
    try {
      await Grape.api().get(`grapes/${this.$route.params.id}?lang=${this.$i18n.locale}`, {
          params: {
            include:
            'grape-variety',
          }
        }
      );
      this.grape = await Grape.query().whereId(this.$route.params.id).withAllRecursive().first();
      this.dataLoaded = true;
    } catch (errors) {
      this.dataLoaded = true;
      errorHandler(errors, this)
    }
  }
}
</script>
